import { useEffect } from "react";
import { List, Typography, Tag, Empty } from "antd";
import { StyledActivities } from "./styles";
import { useTaskActivities } from "../../../../hooks/useTaskActivities";
import Avatar from "../../../../components/generic/Avatar";
import { ACTION_CONFIG } from "./helper";
import { convertDateToFromNow } from "../../../../utils/dayjs";
import { getFullName } from "../../../../utils/shared";

const { Text } = Typography;

const ActivityDescription = ({ activity }) => {
  switch (activity.action) {
    case "title_changed":
    case "description_changed":
    case "column_changed":
    case "comment_edited":
      return (
        <>
          <div className="activity-change">
            <Text>{activity.old_value || "None"}</Text>
          </div>
          <div className="activity-arrow">➞</div>
          <div className="activity-change">
            <Text strong>{activity.new_value || "None"}</Text>
          </div>
        </>
      );
    case "comment_added":
    case "task_created":
      return <Text>{activity.new_value}</Text>;
    default:
      return null;
  }
};

const Activities = ({ task, tenant_id }) => {
  const { fetchActivities, activities, loading } = useTaskActivities(
    task,
    tenant_id,
  );

  useEffect(() => {
    fetchActivities(activities.length);
  }, []);

  return (
    <StyledActivities>
      <List
        loading={loading}
        locale={{
          emptyText: <Empty description="No activity found" />,
        }}
        dataSource={activities}
        renderItem={(activity) => {
          const config = ACTION_CONFIG[activity.action] || {};

          return (
            <List.Item className="activity-item">
              <List.Item.Meta
                avatar={<Avatar user={activity?.user} size={36} />}
                title={
                  <div className="activity-header">
                    <div className="activity-left">
                      <Text strong>{getFullName(activity.user)}</Text>
                      <Text type="secondary" className="activity-date">
                        {convertDateToFromNow(activity.created_at)}
                      </Text>
                    </div>

                    <Tag color={config.color} icon={config.icon}>
                      {config.label}
                    </Tag>
                  </div>
                }
                description={
                  <>
                    <div className="activity-body">
                      <ActivityDescription activity={activity} />
                    </div>
                  </>
                }
              />
            </List.Item>
          );
        }}
      />
    </StyledActivities>
  );
};

export default Activities;
